"use client";

import Image from "next/image";
import Link from "@/components/ui/Link";
import LiveBlink from "@/components/ui/LiveBlink";
import { isLiveBlogValue } from "@/lib/liveBlog";
import { useRouter } from "next/navigation";
import { MessageIcon } from "../ui/message-icon";
import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";
import { getTimeAgo, getSectionUrl, toFieldString } from '@/lib/componentutills';

type FieldConfig = {
  hidden?: boolean;
  value?: string | boolean;
  customClass?: string;
};

type Props = {
  title?: FieldConfig;
  timeAgo?: FieldConfig;
  category?: FieldConfig;
  sectionUrl?: string;
  slug?: string;
  templatetype?: FieldConfig;
  isliveblog?: FieldConfig;
};

export const VerticalCategoryNewsSmall = ({
  title = { hidden: false, value: "யார் கமலின் பெரிய ரசிகர்? இந்த சந்தைையில் சட்டை கிழியாது: லோகேஷ் புகழ்ந்த கொளத்தம் மேனன்!", customClass: "" },
  timeAgo = { hidden: false, value: "1 hour ago", customClass: "" },
  category = { hidden: false, value: "India", customClass: "" },
  sectionUrl,
  slug,
  templatetype  = { hidden: false, value: "", customClass: "" },
  isliveblog = { hidden: false, value: "", customClass: "" },
}: Props) => {
  const router = useRouter();

  const titleValue = toFieldString(title?.value);
  const timeAgoValue = getTimeAgo(toFieldString(timeAgo?.value));
  const categoryValue = toFieldString(category?.value);
  const isLiveBlog = isLiveBlogValue(templatetype?.value) || isLiveBlogValue(isliveblog?.value);
  const sectionUrlValue = getSectionUrl(sectionUrl);

  // Function to truncate title to max 4 lines
  const truncateTitle = (text: string, maxLines: number = 4) => {
    const maxCharsPerLine = 45; // Approximate characters per line for this font size
    const maxChars = maxCharsPerLine * maxLines;

    if (text.length <= maxChars) {
      return text;
    }

    return text.slice(0, maxChars - 3) + "...";
  };

  const handleCategoryClick = (e: React.MouseEvent) => {
    if (sectionUrlValue) {
      e.preventDefault();
      e.stopPropagation();
      router.push(sectionUrlValue);
    }
  };

  const content = (
    <div className="flex flex-col overflow-hidden p-4 gap-4">
      {/* CONTENT */}
      <div className="flex flex-col gap-3 h-auto justify-between">
        <div>
          {/* Category */}
          {!category?.hidden && (
            sectionUrlValue ? (
              <span
                className={`text-11-tamil-600 text-012061 uppercase tracking-wide hover:underline cursor-pointer ${category?.customClass || ""}`}
                onClick={handleCategoryClick}
              >
                {categoryValue}
              </span>
            ) : (
              <p className={`text-11-tamil-600 text-012061 uppercase tracking-wide ${category?.customClass || ""}`}>
                {categoryValue}
              </p>
            )
          )}

          {/* Headline */}
          {!title?.hidden && (
            <p className={`text-16-tamil-700 md:text-14-tamil-600 leading-[1.4] text-1B1B1B ${title?.customClass || ""}`}>
              {isLiveBlog && (
                <LiveBlink />
              )}
              {truncateTitle(titleValue)}
            </p>
          )}
        </div>
        {/* Footer */}
        <div className="flex justify-between items-center">
          {!timeAgo?.hidden && (
            <span className={`text-12-tamil-500 text-1B1B1B ${timeAgo?.customClass || ""}`}>{timeAgoValue}</span>
          )}
          <div className="flex gap-3">
            <MessageIcon
              id="message-icon-2"
              slug={slug}
              category={BOOKMARK_CATEGORIES.NEWS}
              title={titleValue}
              articleUrl={slug ? `/${slug}` : undefined}
            />
          </div>
        </div>
      </div>
    </div>
  );

  if (slug) {
    return (
      <Link href={`/${slug}`} className="block  transition-colors cursor-pointer">
        {content}
      </Link>
    );
  }

  return content;
};
